import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-percent',
  templateUrl: './percent.component.html',
})
export class PercentComponent {
  @Input() data;
  @HostBinding() class = 'flex-1 d-flex justify-content-end';
}
